module.exports = __webpack_public_path__ + "static/media/40a247b1-2840-4953-b24b-8a82ace0673b.9db525b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/40a247b1-2840-4953-b24b-8a82ace0673b.svg
// module id = 87
// module chunks = 0